import { useState } from "react";
import { Link } from "react-router-dom";
import { categories, gossipItems } from "@/mocks/gossip";
import { formatViews, getCategoryName } from "@/utils/format";

export default function RankingSection() {
  const ranked = [...gossipItems].sort((a, b) => b.views - a.views).slice(0, 8);
  const [activeId, setActiveId] = useState(ranked[0].id);
  const active = ranked.find((item) => item.id === activeId) ?? ranked[0];

  return (
    <section id="ranking" aria-labelledby="ranking-title" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-primary-600 uppercase mb-2">
              <span className="w-4 h-px bg-primary-500"></span>
              Daily Ranking
            </span>
            <h2 id="ranking-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              视频吃瓜热度排行榜
            </h2>
            <p className="mt-2 text-sm text-foreground-600">按 24 小时播放增速排序，每小时更新一次。</p>
          </div>
          <span className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
            更新于 09:30
          </span>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <ol className="lg:col-span-7 flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
            {ranked.map((item, index) => (
              <li key={item.id}>
                <button
                  type="button"
                  onMouseEnter={() => setActiveId(item.id)}
                  onFocus={() => setActiveId(item.id)}
                  onClick={() => setActiveId(item.id)}
                  className={`flex w-full cursor-pointer items-center gap-4 px-4 py-3.5 text-left transition-colors ${
                    activeId === item.id ? "bg-primary-50" : "hover:bg-background-100"
                  }`}
                >
                  <span
                    className={`inline-flex items-center justify-center w-8 h-8 flex-shrink-0 rounded-md font-heading font-bold text-sm ${
                      index === 0
                        ? "bg-primary-500 text-background-50"
                        : index === 1 || index === 2
                          ? "bg-accent-500 text-foreground-950"
                          : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate font-heading text-sm font-semibold text-foreground-950">{item.title}</span>
                    <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                        {getCategoryName(item.category, categories)}
                      </span>
                      <span>{formatViews(item.views)} 播放</span>
                    </span>
                  </span>
                  <i
                    className={`ri-arrow-right-up-line w-5 h-5 flex flex-shrink-0 items-center justify-center transition-colors ${
                      activeId === item.id ? "text-primary-600" : "text-foreground-300"
                    }`}
                  ></i>
                </button>
              </li>
            ))}
          </ol>

          <div className="lg:col-span-5">
            <div className="sticky top-24 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="relative w-full h-56 bg-secondary-200">
                <img
                  src={active.cover}
                  alt={`${active.title} 排行榜预览画面`}
                  title={`${active.title} 视频吃瓜 热榜`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-foreground-950 mb-2">
                    <i className="ri-trophy-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    当前热度第一
                  </span>
                  <h3 className="font-heading text-base font-semibold leading-snug text-background-50 line-clamp-2">
                    {active.title}
                  </h3>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm leading-relaxed text-foreground-600 line-clamp-3">{active.excerpt}</p>
                <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-play-circle-line w-4 h-4 flex items-center justify-center"></i>
                    {formatViews(active.views)}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-heart-3-line w-4 h-4 flex items-center justify-center"></i>
                    {formatViews(active.likes)}
                  </span>
                  <span>{active.duration}</span>
                </div>
                <Link
                  to={`/video/${active.id}`}
                  className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 cursor-pointer transition-colors hover:bg-primary-600"
                >
                  <i className="ri-play-circle-fill w-5 h-5 flex items-center justify-center"></i>
                  观看完整内容
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}